import React, { useState } from "react";
import Button from "../Button";
import { isEmailValid } from "@website-builder/utilities-index";
import { EmailFormWrapper } from "./styles";
import PropTypes from "prop-types";
import { callB2CIdentifyEvent } from "@website-builder/utilities/utils/utils.js";

const EmailForm = (props) => {
	const {
		buttonText,
		apiEndPoint,
		formData,
		actionOnSuccess,
		redirectUrl,
		successMessage,
		className,
		callbackOnSuccess,
		callbackOnError,
	} = props;

	const [errorObj, setErrorObj] = useState({ message: "", error: false });
	const [email, setEmail] = useState(null);
	const [successObj, setSuccessObj] = useState({
		message: successMessage,
		success: false,
	});

	const handleInputChange = ({ target: { value } }) => setEmail(value.trim());

	const resetErrorObj = () => {
		setErrorObj({
			message: "",
			error: false,
		});
	};

	const handleFormSubmit = (e) => {
		e.preventDefault();
		// Validate Email
		if (!email) {
			setErrorObj({
				message: "Email is required.",
				error: true,
			});

			return;
		}

		if (!isEmailValid(email)) {
			setErrorObj({
				message: "Please enter valid email.",
				error: true,
			});
			return;
		}

		// Fire api
		postRequest();

		email && callB2CIdentifyEvent(email);

		//Reset the Error Object
		resetErrorObj();
	};

	const onSuccess = () => {
		// Show the success message and callback
		if (actionOnSuccess === "SUCCESS_MESSAGE_AND_CALLBACK") {
			setSuccessObj({
				...successObj,
				success: true,
			});
			callbackOnSuccess();
		}

		// Show the success message
		if (actionOnSuccess === "SHOW_SUCCESS_MESSAGE") {
			setSuccessObj({
				...successObj,
				success: true,
			});

			return false;
		}

		// Redirect to another url
		if (actionOnSuccess === "REDIRECT_TO_URL") {
			window.location.assign(redirectUrl);
		}

		if (actionOnSuccess === "CALLBACK") {
			callbackOnSuccess(email);
		}
		// Fallback success callback provided through props
	};

	const postRequest = () => {
		// Create Form Data as body
		var body = new FormData();
		Object.keys(formData).forEach((key) => {
			body.append(key, formData[key]);
		});
		body.append("email", email);

		fetch(apiEndPoint, {
			method: "POST",
			body,
			referrerPolicy: "no-referrer-when-downgrade",
			credentials: "include",
		})
			.then((res) => res.json())
			.then((response) => {
				const { result = "" } = response;

				if (result === "success") {
					onSuccess();
				}
			})
			.catch((err) => {
				callbackOnError();
			});
	};

	return (
		<EmailFormWrapper
			error={errorObj.error}
			className={className}
			onSubmit={handleFormSubmit}
		>
			{!successObj.success ? (
				<>
					<div className="formGroup formGroupEmail">
						<input
							autoComplete="off"
							type="text"
							placeholder="Enter your email"
							onChange={handleInputChange}
							onFocus={resetErrorObj}
						/>
						<span className="errorMessageWrapper">
							<i className="errorIcon">!</i>
							<label className="errorMessage">{errorObj.message}</label>
						</span>
					</div>
					<div className="formGroup">
						<Button btnType="submit" type="solid" className="submitButton">
							{buttonText}
						</Button>
					</div>
				</>
			) : (
				<div className="successMessageWrapper">
					<img src="https://res.cloudinary.com/springboard-images/image/upload/c_limit,dpr_1.0,f_auto,fl_lossy,q_auto,w_25/v1/homepage-assets/icons/icon-checkmark-green.png" />
					<span className="message">{successObj.message}</span>
				</div>
			)}
		</EmailFormWrapper>
	);
};

EmailForm.propTypes = {
	buttonText: PropTypes.string.isRequired,
	actionOnSuccess: PropTypes.oneOf([
		"SUCCESS_MESSAGE_AND_CALLBACK",
		"SHOW_SUCCESS_MESSAGE",
		"REDIRECT_TO_URL",
		"CALLBACK",
	]).isRequired,
	formData: PropTypes.object,
	redirectUrl: PropTypes.string,
	successMessage: PropTypes.string,
	className: PropTypes.string,
	callbackOnSuccess: PropTypes.func,
	callbackOnError: PropTypes.func,
};

EmailForm.defaultProps = {
	buttonText: "",
	apiEndPoint: "",
	formData: {},
	redirectUrl: "",
	successMessage: "",
	className: "",
	callbackOnSuccess: () => {},
	callbackOnError: () => {},
};

export default EmailForm;
